import { CREATE_EXAM_SCHEDULE, CREATING_EXAM_SCHEDULE, EXAM_SCHEDULES_ERROR, GET_EXAM_SCHEDULES, GETTING_EXAM_SCHEDULES, UPDATE_EXAM_SCHEDULE, UPDATING_EXAM_SCHEDULE } from "../types"

const initialState = {
    examSchedules: [],
    loadingExamSchedules: true,
    examSchedulesError: null,
    creatingExamSchedule: false,
    createdExamSchedule: null,
    updatingExamSchedule: false,
    updatedExamSchedule: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case CREATING_EXAM_SCHEDULE:
        return {
            ...state,
            creatingExamSchedule :action.payload,
        }
        case CREATE_EXAM_SCHEDULE:
        return{
            ...state,
            creatingExamSchedule:false,
            examSchedulesError:  null,
            createdExamSchedule: action.payload,
        }
        case UPDATING_EXAM_SCHEDULE:
        return {
            ...state,
            updatingExamSchedule :action.payload,
        }
        case UPDATE_EXAM_SCHEDULE:
        return{
            ...state,
            updatingExamSchedule:false,
            examSchedulesError:  null,
            updatedExamSchedule: action.payload,
        }
        case GETTING_EXAM_SCHEDULES:
        return {
            ...state,
            loadingExamSchedules :action.payload,
        }
        case GET_EXAM_SCHEDULES:
        return{
            ...state,
            loadingExamSchedules:false,
            examSchedulesError:  null,
            examSchedules: action.payload,
        }
        case EXAM_SCHEDULES_ERROR:
        return{
            ...state,
            loadingExamSchedules:false,
            creatingExamSchedules:false,
            updatingExamSchedules:false,
            examSchedulesError: action.payload 
        }
        default: return state
    }

}